export enum ReportBuilderActionTypes {
    
    GET_CHARTLIST_REPORT='@@ReportBuilder/GET_CHARTLIST_REPORT',
    CHANGE_CHARTS='@@ReportBuilder/CHANGE_CHARTS',
    UPDATE_ELEMENT="@@ReportBuilder/UPDATE_ELEMENT",
    ADD_ELEMENT="@@ReportBuilder/ADD_ELEMENT",
    UPDATE_SECTION_HEIGHT="@@ReportBuilder/UPDATE_SECTION_HEIGHT",
    DELETE_ELEMENT="@@ReportBuilder/DELETE_ELEMENT",

    CHANGE_REPORT_LOCATION='@@ReportBuilder/CHANGE_REPORT_LOCATION',
    CHANGE_CURRENTREPORT='@@ReportBuilder/CHANGE_CURRENTREPORT',
    SET_SECTIONS='@@ReportBuilder/SET_SECTIONS',
    SET_SELECTED='@@ReportBuilder/SET_SELECTED',
    ADD_FILTER = "@@ReportBuilder/ADD_FILTER",
    UPDATE_FILTER = "@@ReportBuilder/UPDATE_FILTER",
    DELETE_FILTER = "@@ReportBuilder/DELETE_FILTER",
    SET_FILTERS = "@@ReportBuilder/SET_FILTERS",
    SET_PREVIEW_FILTER_VALUE = "@@ReportBuilder/SET_PREVIEW_FILTER_VALUE",
    RESET_PREVIEW_FILTERS = "@@ReportBuilder/RESET_PREVIEW_FILTERS",


    
}
